import React from 'react';
import cn from 'classnames';

import './fractional.scss';

interface Props {
    value: string;
}

export default class Fractional extends React.Component<Props> {
    render() {
        const { value } = this.props;

        const [num, denum] = value.split('/');

        return (
            <div
                className="__app-Fractional-container"
                styleName={cn('container', { ['denum-exist']: !!denum })}
            >
                <div styleName="num">{num}</div>
                {denum && <div styleName="denum">{denum}</div>}
            </div>
        );
    }
}
